export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0035s_0000_Black-&-White-10.fa6dc9ce.png";